//Reference: EN116

import { Mappeable } from './mappeable.model';
import moment from 'moment';
import * as _ from 'lodash';


export class ClosePeriod extends Mappeable {

    idClosePeriodPk: number;
    typeClosePeriod: any;
    dateFinish: string;
    mrkActive: boolean;
    exercise: any;

    constructor(o) {
        super(o);
        this.exercise = _.isNumber(this.exercise) ? { year: this.exercise } : this.exercise.year;
        this.dateFinish = moment(this.dateFinish, "YYYY-MM-DD").format("YYYY-MM-DD");
        this.mrkActive = _.isUndefined(this.mrkActive) || _.isNull(this.mrkActive) ? false : this.mrkActive;
    }

    public mapToBack() {
        return {
            typeClosePeriod: this.typeClosePeriod,
            dateFinish: this.dateFinish,
            mrkActive: this.mrkActive,
            exercise: this.exercise
        }
    }


}
